<share-section-card title="User Account" icon="pi pi-user">
  <div class="text-500 text-center mb-4">Welcome to OM!</div>

  <ng-container *ngIf="us.currentUser$ | async as currentUser; else loadingTpl">
    <ul class="list-none p-0 m-0 border-top-1 surface-border">
      <li
        class="flex align-items-center py-3 px-3 flex-wrap"
        *ngFor="let field of profileFields; let i = index"
        [ngClass]="{ 'surface-ground': i % 2 === 0 }"
      >
        <div class="text-500 font-medium w-full md:w-4">{{ field.label }}</div>
        <div class="text-900 w-full md:w-8">{{ resolveField(currentUser, field) }}</div>
      </li>
    </ul>
  </ng-container>

  <ng-template #loadingTpl>
    <p-skeleton height="3rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="3rem" styleClass="mb-2"></p-skeleton>
    <p-skeleton height="3rem"></p-skeleton>
  </ng-template>
</share-section-card>
